<template>
<a class="skip-link hidden" href="#main">Skip to main</a>
  <main class="h-screen block" id="main" style="background: url(/steelhamers_bg.jpg) no-repeat center center fixed; 
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;">
  <div class="grid-cols-12 grid md:h-screen w-full">
    <div class="col-span-12 md:col-start-2 md:col-span-5 md:h-screen">
      <div class="flex items-center md:h-screen">
        <div class="w-full my-6 mx-2">
          <img
            id="logo"
            class="m-auto"
            src="/steelhamers_logo.svg"
            alt="Steel &amp; Hamers"
          />
        </div>
      </div>
    </div>
    <div class="col-span-12 md:col-span-5 text-center uppercase tracking-widest text-d2d2d2">

      <div class="flex md:items-center md:h-screen">
      <div class="m-auto">
        <div class="p-1 mb-1 sm:p-3 sm:mb-3 border-black border-2 inline-block text-black text-md sm:text-xl md:text-2xl xl:text-4xl">Bouw & Kluswerk</div><br />
        <div class="p-1 mb-5 sm:p-3 sm:mb-20 border-black border-2 inline-block text-black text-md sm:text-xl md:text-2xl xl:text-4xl">Montage</div><br />

        <div class="p-1 mb-1 sm:p-3 sm:mb-3 border-black border-2 bg-black inline-block text-md sm:text-xl md:text-2xl xl:text-4xl">Scott Hamers</div><br />
        <div class="p-1 mb-1 sm:p-3 sm:mb-3 border-black border-2 bg-black inline-block text-md sm:text-xl md:text-2xl xl:text-4xl"><a href="tel:0642470804">+31 (0)6 42 47 08 04</a></div><br />
        <div class="p-1 mb-1 sm:p-3 sm:mb-3 border-black border-2 bg-black inline-block text-md sm:text-xl md:text-2xl xl:text-4xl"><a href="mailto:info@steelandhammers.com">info@steelandhammers.com</a></div><br />
        <div class="p-1 mb-1 sm:p-3 sm:mb-3 inline-block text-base md:text-md text-black text-md sm:text-xl md:text-2xl xl:text-4xl"><a href="/steelhamers_av.pdf" target="_blank">Algemene voorwaarden</a></div>
      </div>
      </div>
        
        
    </div>
  </div>
  </main>
</template>

<script>
export default {
  name: "HomeContents",
  props: {
    msg: String,
  },
  mounted() {
    if(window.innerWidth<768){
    var divideBy = 3;
    document.getElementById("logo").style.height =
     (window.innerHeight / divideBy) + "px";
    } else {
    document.getElementById("logo").style.maxHeight =
     ((window.innerHeight)-100) + "px";
    }
  },
};
</script>
